import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { NxModule } from "@nrwl/nx";

import { AppComponent } from "./app.component";
import { CanvasModule } from "./canvas/canvas.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { SliderModule } from "primeng/slider";

@NgModule({
  declarations: [AppComponent],
  imports: [
    CanvasModule,
    BrowserModule,
    BrowserAnimationsModule,
    NxModule.forRoot(),
    SliderModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
